import React from "react";

import "./Header.css";

const Header = (): JSX.Element => (
  <header className="header">
    <h1 className="title">Refuse & Recycling Collection</h1>
    <h2 className="subtitle">City of York</h2>
  </header>
);

export default Header;
